var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.rootElementId}},[_c('center',[_c('canvas',{class:((_vm.visualization === 'heatMap' ? 'canvas_heat_map' : '') + " " + _vm.currentUserFieldColor + "_pitch"),attrs:{"id":_vm.canvasElementId}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-563bf6ec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/base/EventsChart.vue
// module id = null
// module chunks = 